"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingSpinner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * LoadingSpinner component for displaying loading states
 * @param props - LoadingSpinnerProps
 * @returns LoadingSpinner component
 */
const LoadingSpinner = ({ size = 'medium', overlay = false, label = 'Loading...', className = '', }) => {
    const spinnerClasses = ['loading-spinner', `loading-spinner--${size}`, className]
        .filter(Boolean)
        .join(' ');
    const spinner = ((0, jsx_runtime_1.jsxs)("div", { className: spinnerClasses, role: "status", "aria-label": label, children: [(0, jsx_runtime_1.jsx)("svg", { className: "spinner", viewBox: "0 0 50 50", children: (0, jsx_runtime_1.jsx)("circle", { className: "spinner__path", cx: "25", cy: "25", r: "20", fill: "none", strokeWidth: "5" }) }), (0, jsx_runtime_1.jsx)("span", { className: "sr-only", children: label })] }));
    if (overlay) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "loading-spinner-overlay", children: spinner }));
    }
    return spinner;
};
exports.LoadingSpinner = LoadingSpinner;
exports.default = exports.LoadingSpinner;
